export default __webpack_public_path__ + "static/media/loader.698380d9.gif";